"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContentStyled = void 0;

var _uiKit = require("@dbi-tools/ui-kit");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  a {\n    color: currentColor;\n    &:hover {\n      color: currentColor;\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ContentStyled = (0, _uiKit.styled)("div")(_templateObject());
exports.ContentStyled = ContentStyled;